import React, { useEffect, useRef, useState } from "react"

/**
 * Compact play control for call recordings.
 * Renders nothing when url is missing.
 */
const CallRecordingPlayButton = ({ url, status }) => {
  const audioRef = useRef(null)
  const [playing, setPlaying] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    setPlaying(false)
    setError(false)
    if (audioRef.current) {
      audioRef.current.pause()
      audioRef.current.currentTime = 0
    }
  }, [url])

  if (!url) {
    return <span className="text-muted small">—</span>
  }

  const toggle = e => {
    e.preventDefault()
    e.stopPropagation()
    const audio = audioRef.current
    if (!audio) return
    if (playing) {
      audio.pause()
      setPlaying(false)
      return
    }
    audio
      .play()
      .then(() => {
        setPlaying(true)
        setError(false)
      })
      .catch(() => {
        setError(true)
        setPlaying(false)
      })
  }

  return (
    <div className="d-inline-flex align-items-center gap-1">
      <audio
        ref={audioRef}
        src={url}
        preload="none"
        onEnded={() => setPlaying(false)}
        onPause={() => setPlaying(false)}
        onError={() => {
          setError(true)
          setPlaying(false)
        }}
      />
      <button
        type="button"
        className="btn btn-sm btn-soft-primary"
        onClick={toggle}
        title={error ? "Unable to play recording" : playing ? "Pause" : "Play recording"}
        style={{
          minWidth: 34,
          padding: "2px 8px",
          lineHeight: 1.2,
          border: "1px solid #93c5fd",
          backgroundColor: playing ? "#dbeafe" : "#eff6ff",
          color: "#1d4ed8",
          borderRadius: 6,
          fontWeight: 600,
        }}
      >
        <i className={`fas ${playing ? "fa-pause" : "fa-play"}`} aria-hidden />
      </button>
      {error ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="small text-primary"
          title="Open recording"
          onClick={e => e.stopPropagation()}
        >
          Open
        </a>
      ) : status && status !== "linked" && status !== "uploaded" ? (
        <span className="text-muted" style={{ fontSize: "0.65rem" }}>
          {status}
        </span>
      ) : null}
    </div>
  )
}

export default CallRecordingPlayButton
